export default function Hero() {
  const stats = [
    { value: '12,000+', label: '收录漫画' },
    { value: '每日更新', label: '更新频率' },
    { value: '全部分类', label: '精准导航' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20toned%20artistic%20abstract%20manga%20and%20comic%20themed%20illustration%20with%20soft%20ink%20wash%20textures%20and%20subtle%20speech%20bubble%20patterns%20in%20cream%20and%20warm%20orange%20hues%2C%20Japanese%20manga%20panel%20style%20background%20with%20delicate%20line%20art%2C%20minimalist%20clean%20aesthetic%2C%20editorial%20quality%2C%20warm%20light%20gradient%2C%20cinematic%20atmospheric%20composition&width=1440&height=900&seq=hero-bg-manga-01&orientation=landscape"
          alt="漫画主题背景"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/50 to-background-50/90"></div>
      </div>

      <div className="relative z-10 w-full mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-6 md:pt-0">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium tracking-wide mb-5 whitespace-nowrap">
              韩漫推荐 · 日漫大全 · 国漫排行榜
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-900 leading-tight mb-4">
              土豪漫画网<span className="text-primary-500"> — </span>你的漫画分类阅读天堂
            </h1>

            <p className="font-serif text-lg md:text-xl text-foreground-600 mb-4 font-medium">
              海量好漫，一网打尽
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[580px] mx-auto lg:mx-0 mb-8">
              土豪漫画网专注为漫画爱好者提供精准分类阅读体验，覆盖韩漫推荐、日漫大全与国漫排行榜三大核心板块。
              无论你热衷热血战斗、甜蜜恋爱还是烧脑悬疑，这里都有适合你的好漫画。
              我们每日更新最新章节，确保你不错过任何精彩内容，让发现好漫画变得简单又愉快。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="font-heading text-xl md:text-2xl text-primary-500">{s.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-fire-line"></i>
                查看热门排行
              </a>
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 border border-background-300/60 rounded-full font-medium text-sm hover:bg-background-200 transition-all whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-compass-3-line"></i>
                探索漫画索引
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[540px]">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-100/40 rounded-3xl blur-3xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=A%20beautiful%20manga%20style%20illustration%20featuring%20dynamic%20comic%20panel%20collage%20with%20vibrant%20warm%20colors%2C%20multiple%20manga%20characters%20in%20different%20art%20styles%20merging%20together%2C%20action%20lines%20and%20concentration%20lines%20background%2C%20Japanese%20comic%20aesthetic%20with%20modern%20twist%2C%20clean%20composition%20on%20light%20cream%20background%2C%20editorial%20quality%20artwork%2C%20warm%20orange%20and%20coral%20accents&width=1080&height=800&seq=hero-manga-visual-02&orientation=portrait"
                alt="土豪漫画网 - 漫画分类阅读主题视觉"
                className="relative w-full h-auto rounded-2xl object-cover"
                title="土豪漫画网漫画分类阅读"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}